import { required } from "vuelidate/lib/validators";
export default {
    spkb_detail_form: {
        true: {
            spkbForm: {
                delivery_date: { required },
                driver: { required },
                delivery_to: { required },
                send_to_dc: { required },
                invoice_pic: { required },
                spkb_type: { },
                notes: {}
            },
            spkbDetailForm: {
                order_number: { required }
            }
        },
        false: {
            spkbForm: {
                delivery_date: { required },
                driver: { required },
                delivery_to: { required },
                send_to_dc: {},
                invoice_pic: { required },
                spkb_type: { },
                notes: {}
            },
            spkbDetailForm: {
                order_number: { required }
            }
        }
    },
    customer_details: {
        customer_group_indomaret_detail_true: {
            customerForm: {
                name: { required },
                customer_group: { required },
                zone: { required },
                owner_name: { required },
                mobile_phone: { required },
                mobile_phone2: {},
                mobile_phone3: {},
                lat: { required },
                lng: { required },
                bank_account_name: {},
                bank_account_number: {},
                address: { required },
                order_time_id: { required },
                vehicle_delivery_id: { required },
                customer_code: { required },
                bill_address: { required },
                source_delivery: { },
                route_delivery: { required },
                status: { required },
                company_for_letter: { required },
                province: { required },
                regencies: { required },
                district: { required },
                villages: { required },
                ktp_number: { required },
                address_ktp: { required }
            }
        },
        customer_group_indomaret_detail_false: {
            customerForm: {
                name: { required },
                customer_group: { required },
                zone: { required },
                owner_name: { required },
                mobile_phone: { required },
                mobile_phone2: {},
                mobile_phone3: {},
                lat: { required },
                lng: { required },
                bank_account_name: {},
                bank_account_number: {},
                address: { required },
                order_time_id: { required },
                vehicle_delivery_id: { required },
                customer_code: { required },
                bill_address: { required },
                source_delivery: { },
                route_delivery: { required },
                status: { required },
                company_for_letter: { required },
                province: { required },
                regencies: { required },
                district: { required },
                villages: { required },
                ktp_number: { required },
                address_ktp: { required }
            }
        },
        customer_group_notindomaret_detail_true: {
            customerForm: {
                name: { required },
                customer_group: { required },
                zone: { required },
                owner_name: { required },
                mobile_phone: { required },
                mobile_phone2: {},
                mobile_phone3: {},
                lat: { required },
                lng: { required },
                bank_account_name: {},
                bank_account_number: {},
                address: { required },
                order_time_id: { },
                vehicle_delivery_id: { },
                customer_code: {},
                bill_address: { },
                source_delivery: { },
                route_delivery: { },
                status: { required },
                company_for_letter: { required },
                province: { required },
                regencies: { required },
                district: { required },
                villages: { required },
                ktp_number: { required },
                address_ktp: { required }
            }
        },
        customer_group_notindomaret_detail_false: {
            customerForm: {
                name: { required },
                customer_group: { required },
                zone: { required },
                owner_name: { required },
                mobile_phone: { required },
                mobile_phone2: {},
                mobile_phone3: {},
                lat: { required },
                lng: { required },
                bank_account_name: {},
                bank_account_number: {},
                address: { required },
                order_time_id: { },
                vehicle_delivery_id: { },
                customer_code: {},
                bill_address: { },
                source_delivery: { required },
                route_delivery: { },
                status: { required },
                company_for_letter: { required },
                province: { required },
                regencies: { required },
                district: { required },
                villages: { required }
            }
        }
    },
    employee: {
        true: {
            employeeForm: {
                name: { required },
                surename: {},
                username: {},
                email: { required },
                start_join: { required },
                end_date: {},
                mobile_phone: { required },
                division_id: { required },
                position_id: { required },
                payment_method: { required },
                bank_account_number: { required },
                address: { required },
                id_number: { required },
                bank_account_name: {},
                bank_name: { required },
                parent: {},
                status: {},
                authorization: {},
                employee_ho: { required },
                religion: { required },
                shift: { required },
                company: { required }
            }
        },
        false: {
            employeeForm: {
                name: { required },
                surename: {},
                username: { required },
                email: { required },
                start_join: { required },
                end_date: {},
                mobile_phone: { required },
                division_id: { required },
                position_id: { required },
                payment_method: { required },
                bank_account_number: { required },
                address: { required },
                id_number: { required },
                bank_account_name: {},
                bank_name: { required },
                parent: {},
                status: {},
                authorization: {},
                employee_ho: { required },
                religion: { required },
                shift: { required },
                company: { required }
            }
        }
    },
    customer: {
        true: {
            customerForm: {
                name: { required },
                customer_group: { required },
                zone: { required },
                owner_name: {  },
                mobile_phone: { required },
                mobile_phone2: {},
                mobile_phone3: {},
                lat: { required },
                lng: { required },
                bank_account_name: {},
                bank_account_number: {},
                address: {  },
                order_time_id: { required },
                vehicle_delivery_id: { required },
                customer_code: {  },
                province: { required },
                regencies: { required },
                district: { required },
                villages: { required },
                ktp_number: { required },
                address_ktp: { required } 
            }
        },
        false: {
            customerForm: {
                name: { required },
                customer_group: { required },
                zone: { required },
                owner_name: {  },
                mobile_phone: { required },
                mobile_phone2: {},
                mobile_phone3: {},
                lat: { required },
                lng: { required },
                bank_account_name: {},
                bank_account_number: {},
                address: {  },
                order_time_id: { required },
                vehicle_delivery_id: { required },
                customer_code: {},
                province: { required },
                regencies: { required },
                district: { required },
                villages: { required },
                ktp_number: { required },
                address_ktp: { required } 
            }
        }
    },
    assets: {
        add: {
            assetForm: {
                asset_owner_id: { required },
                serial_number: { required },
                file: { },
                description: {},
                status:{required},
                image_information: {},
            }
        },
        edit: {
            assetForm: {
                asset_owner_id: { required },
                serial_number: { required },
                file: { },
                description: {},
                status: {required},
                image_information: {},
            }
        }
    },
    task: {
        add: {
            taskCoverageForm: {
                employee_id: { required },
                related_non_gt: { },
                related_gt: { },
                related_zone: { },
                related_customer_group: { }

            }
        },
        edit: {
            taskCoverageForm: {
                employee_id: { required },
                related_non_gt: { },
                related_gt: { },
                related_zone: { },
                related_customer_group: { }
            }
        }
    },
    task_cvo: {
        add: {
            taskCoverageForm: {
                employee_id: { required },
                related_non_gt: { },
                related_gt: { },
                related_zone: { },
                related_customer_group: { }
            }
        },
        edit: {
            taskCoverageForm: {
                employee_id: { required },
                related_non_gt: { },
                related_gt: { },
                related_zone: { },
                related_customer_group: { }
            }
        }
    },
    migrationTask: {
        add: {
            taskMigrationForm: {
                assigned_to: { required },
                assigned_prev: { required }
            }
        },
        edit: {
            taskMigrationForm: {
                assigned_to: { required },
                assigned_prev: { required }
            }
        }
    },
    bankBook: {
        CR: {
             transactionDetailForm: {
                bank_of_account: {required},           
                transaction_date: {required},     
                description: {required},
                mutation: {required},
                mutation_type: {required},
                total: {required},
                category: { },
                transaction_type: { },
                detail_description: { },
                spkb_a: { },
                spkb_b: { },
                spkb_c: { },
                spkb_d: { },
                spkb_e: { },
                spkb_f: { },
                spkb_g: { },
                spkb_h: { },
                spkb_i: { },
                spkb_j: { },
                spkb_k: { },
                spkb_l: { },
                spkb_m: { },
                spkb_n: { },
                spkb_o: { },
                piutang_spkb_a: { required },
                piutang_spkb_b: {  },
                piutang_spkb_c: {  },
                piutang_spkb_d: {  },
                piutang_spkb_e: {  },
                piutang_spkb_f: {  },
                piutang_spkb_g: {  },
                piutang_spkb_h: {  },
                piutang_spkb_i: {  },
                piutang_spkb_j: {  },
                piutang_spkb_k: {  },
                piutang_spkb_l: {  },
                piutang_spkb_m: {  },
                piutang_spkb_n: {  },
                piutang_spkb_o: {  }
            }
        },
        DB: {
            transactionDetailForm: {
                bank_of_account: {required},           
                transaction_date: {required},     
                description: {required},
                mutation: {required},
                mutation_type: {required},
                total: {required},
                category: {required},
                transaction_type: {required},
                detail_description: { },
                spkb_a: { },
                spkb_b: { },
                spkb_c: { },
                spkb_d: { },
                spkb_e: { },
                spkb_f: { },
                spkb_g: { },
                spkb_h: { },
                spkb_i: { },
                spkb_j: { },
                spkb_k: { },
                spkb_l: { },
                spkb_m: { },
                spkb_n: { },
                spkb_o: { },
                piutang_spkb_a: {  },
                piutang_spkb_b: {  },
                piutang_spkb_c: {  },
                piutang_spkb_d: {  },
                piutang_spkb_e: {  },
                piutang_spkb_f: {  },
                piutang_spkb_g: {  },
                piutang_spkb_h: {  },
                piutang_spkb_i: {  },
                piutang_spkb_j: {  },
                piutang_spkb_k: {  },
                piutang_spkb_l: {  },
                piutang_spkb_m: {  },
                piutang_spkb_n: {  },
                piutang_spkb_o: {  }
            }
        }
    },
    verification_agreement_freezer: {
        add: {
              employeeTaskVerificationForm: {
                    title: { required },
                    subtitle: {},
                    employee_id: { required },
                    customer_id: { required },
                    template_id: { required },
                    freezer_request_code: { required },
                    status_verification: {  },
                    reason: {  },
                    date_show_task: {},
                    category: {},
                    date_inserted: {},
                    updated_time: {},
                    status: {}
                },
        },
        edit: {
            employeeTaskVerificationForm: {
                    title: { required },
                    subtitle: {},
                    employee_id: { required },
                    customer_id: { required },
                    template_id: { required },
                    freezer_request_code: { required },
                    status_verification: { required },
                    reason: { required },
                    date_show_task: {},
                    category: {},
                    date_inserted: {},
                    updated_time: {},
                    status: {}
                    },
            }
        }
    
}
